import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from '@app/app.design.module';
import { ErrorInterceptor } from '@app/helpers/ErrorInterceptor';
import { LogExcecaoComponent } from '@componentes/log-excecao/log-excecao.component';

import { CamerasComponent } from '@componentes/cameras/cameras.component';
import { PiscinaoDetalheComponent } from '@componentes/piscinao_detalhe/piscinao_detalhe.component';
import { PiscinoesComponent } from '@componentes/piscinoes/piscinoes.component';
import { ReportsComponent } from '@componentes/reports/reports.component';
import { PainelArrastavelBase } from '@componentes/shared/PainelArrastavelBase';
import { AlertComponent } from '@componentes/shared/alert/alert.component';
import { CarregandoComponent } from '@componentes/shared/carregando/carregando.component';
import { LoadingComponent } from '@componentes/shared/loading/loading.component';
import { ModalExternoComponent } from '@componentes/shared/modal-externo/modal-externo.component';
import { TuneisComponent } from '@componentes/tuneis/tuneis.component';
import { ContaService } from '@services/conta.service';
import { LoadingService } from '@services/loading.service';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CompartilhadoModule } from './compartilhado/compartilhado.module';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { SafeHTMLPipe, SafeURLPipe } from './pipes/safe.pipe';

registerLocaleData(ptBr);

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {};

@NgModule({
  declarations: [
    AppComponent,
    SafeURLPipe,
    SafeHTMLPipe,
    LinkifyPipe,
    CamerasComponent,
    CarregandoComponent,
    PiscinoesComponent,
    PiscinaoDetalheComponent,
    TuneisComponent,
    ReportsComponent,
    ModalExternoComponent,
    LoadingComponent,
    LogExcecaoComponent,
    AlertComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    GoogleMapsModule,
    CompartilhadoModule,
    DigitOnlyModule,
    HttpClientModule,
    MaterialModule,
    PerfectScrollbarModule,
    ReactiveFormsModule,
    NgxDaterangepickerMd.forRoot()
  ],
  providers: [
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ContaService,
    PainelArrastavelBase,
    DatePipe,
    LoadingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
